import styled from "styled-components";

export const Nav = styled.nav`
    position: relative;
    width: 300px;
    margin: 0 auto;
`;

export const Logo = styled.h1`
    position: relative;
    font-size: 40px;
    font-family: 'Luckiest Guy';
    color: #ffffff;
    text-align: center;
    text-shadow: -1px 1px 0 #000,
        0 0 3px #252525, 0 0 5px #ffffff,
            1px 1px 0 #000,
            1px -1px 0 #000,
            -1px -1px 0 #000;
`;
